<template>
  <div>

    <a-card :title="`${application.ew_app_name}`" :bordered="false">
        <a-button type="primary" size="small" slot="extra" @click="visible = true">Edit</a-button>
        <p>Name: {{application.ew_app_name}}</p>
        <p>Url: {{application.ew_url}}</p>
        <p>Secret: **************************</p>
        <hr>
    </a-card>
     <a-modal
          :footer="null"
          title="Edit application details!"
          :visible="visible"
          @cancel="handleCancelAction"
          >
          <a-row>
            <form @submit="updateApplication" id="form_zoom">

              <a-form-item label="App name" >
                <a-input id="app_name" name="app_name" v-model="form.name" placeholder="Application app_name" required/>
              </a-form-item>
              <a-form-item label="Secret" >
                <a-input id="secret" type="password" name="secret" v-model="form.secret" placeholder="Application secret" minlength="20" required/>
              </a-form-item>
              <a-form-item label="Url" >
                <a-input addon-before="https://" id="url" name="url" v-model="form.url" placeholder="Application url" required/>
              </a-form-item>
              <a-form-item label="Logo" >
                <input type="file" class="form-control" id="logo" name="logo" :title="application.ew_logo">
              </a-form-item>
              <button type="submit" class="btn btn-outline-success waves-effect waves-themed pull-right">Save</button>
            </form>
        </a-row>
      </a-modal>

  </div>
</template>
<script>

import API from '../../../services/api';

export default {
    props:["addNewUser"],
    data(){
       return {
        loading:false,
        application:{},
        visible: false,
        form: {
          name:'',
          url:'',
          secret:''
        },
    };
  },
  computed: {
    userLogin() {
      return this.$store.state.auth.user;
    }
  },
  created(){
      this.getApplications();
  },
  methods: {
    goBack(){
      return this.$router.go(-1)
    },
    async updateApplication(e) {
      e.preventDefault();
        var formel       = 	document.getElementById('form_zoom');
        var formData = new FormData(formel);
        API.put(`/api/admin/applications/${this.$route.params.id}`,formData)
        .then(response => {
           this.resetForm()
           this.visible = false;
           this.getApplications()
          
        })
    },
    async resetForm(){
      document.getElementById("logo").value = "";
       this.form = {
          name:'',
          url:'',
          secret:''
        }
    },
    async getApplications(){
        API.get(`/api/admin/applications/${this.$route.params.id}`)
        .then(res => { 
            this.application = res.data[0];
            this.form = {
              name: this.application.ew_app_name,
              url:this.application.ew_url,
              secret: this.application.ew_secret
            }
            console.log(this.application)
            this.loading = true
        })
        .catch(error => console.log(error));
    },
    handleCancelAction(e) {
        this.visible = false;
    },
  }
};
</script>
<style>
</style>
